import { render, staticRenderFns } from "./TopModel.vue?vue&type=template&id=4c176f2d"
import script from "./TopModel.vue?vue&type=script&lang=js"
export * from "./TopModel.vue?vue&type=script&lang=js"
import style0 from "./TopModel.vue?vue&type=style&index=0&id=4c176f2d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports